/**
 * Cleanup localStorage - Remove all business data
 * Only keep auth tokens and UI preferences
 */

export const cleanupLocalStorage = () => {
    const allowedKeys = [
        'authToken',
        'user',
        'company',
        'theme',
        'darkMode',
        'sidebarOpen',
        // PRESERVE DOCUMENT KEYS - DO NOT DELETE
        'sharedDocumentPool',
        'universalCompanyDocuments',
        'FORCE_UNIVERSAL_DOCUMENTS',
        'PROTECTED_DOCUMENT_STORAGE',
        'allReceivedDocuments',
        'generatedDocuments',
        'documentTemplates',
        'selectedDocumentTemplates',
        'draftDocuments'
    ];

    const keysToRemove = [];

    // Collect all keys that should be removed
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);

        // PRESERVE any key containing 'Document' or 'document'
        if (key && (key.includes('Document') || key.includes('document'))) {
            continue; // Don't remove document keys
        }

        // PRESERVE employee document keys
        if (key && key.startsWith('employeeDocuments_')) {
            continue; // Don't remove employee document keys
        }

        if (!allowedKeys.includes(key)) {
            keysToRemove.push(key);
        }
    }

    // Remove unwanted keys
    keysToRemove.forEach(key => {
        //console.log(`Removing localStorage key: ${key}`);
        localStorage.removeItem(key);
    });

    //console.log(`Cleaned up ${keysToRemove.length} localStorage keys`);
    //console.log('Kept auth and theme keys:', allowedKeys);
};

// List of keys that should be removed
export const DEPRECATED_STORAGE_KEYS = [
    'hrportal_employees',
    'hrportal_onboarding',
    'hrportal_onboarding_config',
    'hrportal_attendance',
    'hrportal_leaves',
    'hrportal_payroll',
    'hrportal_notifications',
    'hrportal_holidays',
    'hrportal_company_settings',
    'hrportal_functional_structure',
    'hrportal_document_templates',
    'employee_data',
    'onboarding_data',
    'attendance_data',
    'leave_data',
    'payroll_data',
    'notification_data'
];

// Clean up on load
if (typeof window !== 'undefined') {
    // Remove deprecated keys immediately
    DEPRECATED_STORAGE_KEYS.forEach(key => {
        if (localStorage.getItem(key)) {
            console.warn(`Removing deprecated localStorage key: ${key}`);
            localStorage.removeItem(key);
        }
    });
}